import { render } from "./ColorPopover.vue?vue&type=template&id=1024b7a4&ts=true"
import script from "./ColorPopover.vue?vue&type=script&lang=ts"
export * from "./ColorPopover.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__